import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../modules/infra/i18n';

const BlockTimeButton = ({ onClick }) => (
  <div className="o-flexbox__item u-ml--">
    <button
      className="c-btn c-btn--medium c-btn--ghost"
      onClick={onClick}
      data-automation-id="button:blockTime"
    >
      {t('appointment:side_by_side.block_time_button')}
    </button>
  </div>
);
BlockTimeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BlockTimeButton;
